import App from "@/App.vue"
import { filters } from "@/aygulyazilim/helpers"
import { registerPlugins } from "@core/utils/plugins"
import { registerLicense } from "@syncfusion/ej2-base"
import { registerSW } from 'virtual:pwa-register'
import { createApp } from "vue"
import Vue3Filters from "vue3-filters"

// Styles
import "@core/scss/template/index.scss"
import "@styles/styles.scss"

// Buffer polyfill
import { Buffer } from 'buffer'

globalThis.Buffer = Buffer

// Service worker registration
registerSW({ immediate: true })

// PWA install prompt event listener
window.addEventListener('beforeinstallprompt', e => {
  e.preventDefault()
  window.deferredPrompt = e
})

// Registering Syncfusion license key
registerLicense(
  "Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH5cdnVWQmhfUkdyX0E=",
)


// Create vue app
const app = createApp(App)

// Register plugins
registerPlugins(app)

app.config.globalProperties.$filters = { ...Vue3Filters.filters, ...filters }

// .env dosyasındaki VITE_API_BASE_URL değişkenini global olarak tanımlıyoruz
app.config.globalProperties.$config = {
  apiBaseUrl: import.meta.env.VITE_API_ENDPOINT.endsWith("/")
    ? import.meta.env.VITE_API_ENDPOINT
    : import.meta.env.VITE_API_ENDPOINT + "/",
}

// Mount vue app
app.mount("#app")
